import {
    Grid,
    DesignBoardPreviewTile,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import * as S from './BoardTileGrid.style';
import type { DesignBoardPreviewProps } from '@modules/design-board/util/map-member-board-list-pin-data';
import { Link } from '@remix-run/react';
import { pluralize } from '~/utils';
import OverlayButtons from '~/modules/design-board/component/board-list/OverlayButtons';
import type { BoardListWithImageOnlyPinsFragment } from 'generated/graphql';

interface BoardTileGridProps {
    boardListData: BoardListWithImageOnlyPinsFragment[];
    previewListData: DesignBoardPreviewProps[];
}

interface BoardTileProps {
    boardData?: BoardListWithImageOnlyPinsFragment;
    previewData: DesignBoardPreviewProps;
}

const BoardTileGrid = ({
    boardListData,
    previewListData,
}: BoardTileGridProps) => {
    const { css } = useStyles({});
    const { mobile } = useAppDisplayModeContext();

    return (
        <Grid className={css(S.BaseGridStyle)} columns={mobile ? 1 : 4}>
            {previewListData.map((board) => {
                const rawBoard = boardListData.find((b) => b.ID === board.id);

                return (
                    <BoardTile
                        key={board.id}
                        previewData={board}
                        boardData={rawBoard}
                    />
                );
            })}
        </Grid>
    );
};

export default BoardTileGrid;

const BoardTile = ({ boardData, previewData }: BoardTileProps) => {
    const fileExtensions = fileExtensionLabelFactory(
        previewData.fileExtensions
    );
    const { css } = useStyles({ fileExtensions });
    const { mobile } = useAppDisplayModeContext();

    return (
        <div className={css(S.TileWrapper)} key={previewData.id}>
            <OverlayButtons board={boardData} />
            <Link to={previewData.link} prefetch="intent">
                <DesignBoardPreviewTile
                    images={previewData.images ?? []}
                    mainText={previewData.label}
                    subText={pluralize(previewData.pins, 'pin')}
                    variant={mobile ? '04' : '03'}
                />
            </Link>
        </div>
    );
};
const fileExtensionLabelFactory = (extensions: string[] = []) => {
    const style = extensions.map((ext) => {
        return {
            [`& .pin-tile-${ext}:before`]: {
                content: `"${ext}"`,
            },
        };
    });

    return style.reduce((r, c) => Object.assign(r, c), {});
};
